import { Box, Button, Flex, Highlight, Text } from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getglobalStoreObject } from "../Stores/globalStore";
import { FaHome } from "react-icons/fa";

function Help() {
  const navigate = useNavigate();

  const globalStore = useSelector(getglobalStoreObject);
  const _dispatch = useDispatch();
  return (
    <Box width={"100%"}>
      <Box h={"15vh"}></Box>
      <Box justifyItems={"center"}>
        <Box
          justifyItems={"center"}
          w={globalStore.isMobile ? "90%" : "40%"}
          p={2}
          borderRadius={"md"}
          border={"1px"}
          borderRight={"4px"}
          borderBottom={"4px"}
          borderColor={"gray.500"}
        >
          <Flex p={2} justifyContent={"space-between"} w={"100%"}>
            <Link to={"/"}>
              <Button
                rightIcon={<FaHome></FaHome>}
                border={"1px"}
                borderRight={"4px"}
                borderBottom={"4px"}
                borderColor={"blue"}
              >
                Home
              </Button>
            </Link>
          </Flex>
          <Box p={2}>
            <Highlight
              query={["regabriele375@gmail.com"]}
              styles={{ px: "2", py: "1", rounded: "full", bg: "teal.100" }}
            >
              {
                "Dear fellow investor, if you had any trouble or error using our webApp, please contact us at regabriele375@gmail.com and we will be able to help you as soon as possible :)"
              }
            </Highlight>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Help;
